const catalogacaoLocalizeEn = {
  'need to send a provider to update': 'Need to send a provider to update',
  cataloging: 'Cataloging'
};

export default catalogacaoLocalizeEn;
